import {
  faSparkles,
  faMessages,
  faMessageBot,
  faUsers,
  faUserHeadset,
  faMicrochipAi,
  faGear,
  faChartLine,
  faTimer,
  faFileLines,
  faBell,
  faCalendarDays,
  faArrowRightToBracket,
  faDisplayChartUp,
  faMagnifyingGlassChart,
  faLightbulbExclamationOn,
  faCircleUser,
  faTrophyStar,
  faFolderMagnifyingGlass,
  faArrowRightFromBracket,
  faHeadset,
  faPeopleGroup,
  faNetworkWired,
  faTag,
  faFolderOpen,
  faBriefcase,
  faFile,
  faGears,
  faTerminal,
  faFileImport,
  faLocationCrosshairs,
  faAt,
  faMessagesQuestion,
  faArrowProgress,
  faSliders,
  faUserPlus,
  faClock,
  faStopwatch,
  faMessageXmark,
  faMessageCheck,
  faSquareCheck,
  faCircleQuestion,
  faMessageQuestion,
  faUserLock,
  faMobileScreenButton,
  faBadgeCheck,
  faPaperclip,
  faPaperPlane,
  faFaceSmile,
  faLightbulbOn,
  faScreencast,
  faPersonFromPortal,
  faStar as faStarSolid,
  faCheck,
  faGlobePointer,
  faAngleRight,
  faAngleDown,
  faMessageLines,
  faExclamation,
  faCircleInfo,
  faPlus,
  faMemoPad,
  faCalendarClock,
  faUpload,
  faDownload,
  faFileCsv,
  faTrashCanXmark,
  faCommentSlash,
  faThumbsUp,
  faThumbsDown,
  faBrainCircuit,
  faShieldCheck,
  faFilePdf,
  faFileDoc,
  faFilePpt,
  faFileJpg,
  faXmark,
  faFilePng,
  faFileGif,
  faFolder,
  faEye,
  faGearCode,
  faBullhorn,
  faFileContract,
  faImage,
  faSun,
  faFileSvg,
  faMoon,
  faSitemap,
  faTimes,
  faReply,
  faEdit,
  faArrowRotateLeft,
  faRectangleHistory,
  faShuffle,
  faAngleDoubleRight,
  faLightbulbMessage,
  faFilter,
  faSquareMinus,
} from '@fortawesome/pro-solid-svg-icons';
import { faArrowProgress as faArrowProgressSharp } from '@fortawesome/sharp-solid-svg-icons';
import {
  faStar as faStarRegular,
  faMessageBot as faMessageBotRegular,
  faThumbsUp as faThumbsUpRegular,
  faThumbsDown as faThumbsDownRegular,
} from '@fortawesome/pro-regular-svg-icons';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import { faHubspot } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(
  faSpinner,
  faSparkles,
  faArrowRotateLeft,
  faRectangleHistory,
  faMessages,
  faMessageBot,
  faAngleDoubleRight,
  faEdit,
  faUsers,
  faUserHeadset,
  faMicrochipAi,
  faGear,
  faChartLine,
  faTimer,
  faTimes,
  faFileLines,
  faXmark,
  faBell,
  faCalendarDays,
  faArrowRightToBracket,
  faDisplayChartUp,
  faMagnifyingGlassChart,
  faLightbulbExclamationOn,
  faCircleUser,
  faTrophyStar,
  faFolderMagnifyingGlass,
  faArrowRightFromBracket,
  faHeadset,
  faPeopleGroup,
  faNetworkWired,
  faPaperPlane,
  faTag,
  faFolderOpen,
  faBriefcase,
  faFile,
  faGears,
  faTerminal,
  faFileImport,
  faLocationCrosshairs,
  faAt,
  faMessagesQuestion,
  faArrowProgress,
  faSliders,
  faUserPlus,
  faClock,
  faReply,
  faFileContract,
  faStopwatch,
  faMessageXmark,
  faMessageCheck,
  faSquareCheck,
  faCircleQuestion,
  faMessageQuestion,
  faUserLock,
  faMobileScreenButton,
  faMessageBotRegular,
  faBadgeCheck,
  faPaperclip,
  faFaceSmile,
  faLightbulbOn,
  faScreencast,
  faPersonFromPortal,
  faArrowProgressSharp,
  faStarRegular,
  faStarSolid,
  faCheck,
  faGlobePointer,
  faAngleRight,
  faAngleDown,
  faMessageLines,
  faExclamation,
  faCircleInfo,
  faPlus,
  faMemoPad,
  faCalendarClock,
  faUpload,
  faDownload,
  faTrashCanXmark,
  faCommentSlash,
  faThumbsUp,
  faThumbsUpRegular,
  faThumbsDown,
  faThumbsDownRegular,
  faBrainCircuit,
  faShieldCheck,
  faBullhorn,
  faFilePdf,
  faFileDoc,
  faFileCsv,
  faFilePpt,
  faFileJpg,
  faFilePng,
  faFileGif,
  faFolder,
  faEye,
  faGearCode,
  faImage,
  faSun,
  faMoon,
  faFileSvg,
  faSitemap,
  faShuffle,
  faLightbulbMessage,
  faFilter,
  faHubspot,
  faSquareMinus,
);
